import { Box } from "@mui/material";

const PdfThumbnailViewer = ({
  base64Data,
  fileType,
  Thumbnails,
  renderThumbnailItem,
}) => {
  return (
    <Box
      sx={{
        width: "15%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {base64Data && fileType === "application/pdf" ? (
        <Thumbnails renderThumbnailItem={renderThumbnailItem} />
      ) : null}
    </Box>
  );
};

export default PdfThumbnailViewer;
